//Search api calls 
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
export const getConfigApi = createApi({
    reducerPath: 'configApi',
    baseQuery: fetchBaseQuery({
        baseUrl: '/api/config/configurations',
        prepareHeaders: (headers) => {
            headers.set("Content-Type", "application/json");
            return headers;
        }
    }),
    endpoints: (builder) => ({
        getConfigurations: builder.query<{ response?: any, isSuccess: any, result: any }, any>({
            query: params => ({
                url: '',
                method: 'POST',
                body: params
            }),
            transformResponse: (response: { message: any }) => {
                return response.message;
            },

        }),
    }),

});
export const { useGetConfigurationsQuery } = getConfigApi;

